import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getLeadsRequest: ['payload'], // payload: { query }
  getLeadsSuccess: ['payload'], // payload: { data }
  getLeadsFailure: ['payload'], // payload: { errors }

  sendSelectedDataRequest: ['payload'], // payload: { query }
  sendSelectedDataSuccess: ['payload'], // payload: { data }
  sendSelectedDataFailure: ['payload'], // payload: { errors }

  sendTaskRequest: ['payload'], // payload: { query }
  sendTaskSuccess: ['payload'], // payload: { data }
  sendTaskFailure: ['payload'], // payload: { errors }

  getCitiesListAdminRequest: ['payload'], // payload: { data },
  getCitiesListAdminSuccess: ['payload'], // payload: { data }
  getCitiesListAdminFailure: ['payload'], // payload: { errors }

  resetApiEndpoints: null, // payload: {}
  resetResults: null, // payload: {}
  resetErrors: null, // payload: {}

  // getNewDashboardInfoRequest: ['payload'], // payload: { link }
  // getNewDashboardInfoSuccess: ['payload'], // payload: { data }

  // getNextDashboardInfoRequest: ['payload'], // payload: { link }
  // getNextDashboardInfoSuccess: ['payload'], // payload: { data }
})

export const LeadsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  leads: null,
  fetching: false,
  result: null,
  errors: false,
  page: 1,
  page_size: 20,
  search: '',
  count_available: null,
  api_endpoints: null,
  pre_create_result: null,
  cityResultAdmin: null,

});

/* ------------- Functions for reducer cases ------------- */

const getLeadsRequest = (state, { payload: query }) => {
  console.log('get leads query', query)
  const newState = {
    fetching: true
  };
  if (query.page) newState.page = query.page;
  if (query.page_size) newState.page_size = query.page_size;
  // if (query.ordering) newState.ordering = query.ordering;
  newState.search = query.q || '';
  return state.merge(newState)
}
const getLeadsSuccess = (state, { payload: leads }) =>{
  // console.log(leads)
  return state.merge({ fetching: false, leads})
}
const getLeadsFailure = (state, {payload: {errors}}) =>
  state.merge({fetching: false, errors})


const sendSelectedDataRequest = (state, { payload: params }) => {
  return state.merge({ fetching: true })
}
const sendSelectedDataSuccess = (state, { payload: result }) => {
  return state.merge({ 
    fetching: false, 
    api_endpoints: result.api_endpoints, 
    count_available: result.count,
    pre_create_result: result
  })
}
const sendSelectedDataFailure = (state, {payload: {errors}}) =>
  state.merge({fetching: false, errors})


const sendTaskRequest = (state, { payload: params }) => {
  return state.merge({ fetching: true })
}
const sendTaskSuccess = (state, { payload: result }) =>{
  return state.merge({ fetching: false, result })
}
const sendTaskFailure = (state, {payload: {errors}}) =>
  state.merge({fetching: false, errors})


//get cities list
export const getCitiesListAdminRequest = (state, { payload: data }) => {
  return state.merge({ fetching: true });
}
export const getCitiesListAdminSuccess = (state, { payload: data }) => {
  return state.merge({ fetching: false, cityResultAdmin: data });
};
export const getCitiesListAdminFailure = (state, { payload: { errors } }) => {
  return state.merge({ fetching: false, errors });
}



export const resetApiEndpoints = (state, {}) => {
  return state.merge({ 
    api_endpoints: null,
    count_available: null,
    pre_create_result: null,
  });
}


export const resetResults = (state, {}) => {
  return state.merge({ 
    result: false,
    pre_create_result: false,
    cityResultAdmin: null,
  });
}

export const resetErrors = (state, {}) => {
  return state.merge({ errors: null });
}

// const getNewDashboardInfoRequest = (state) => state.merge({ fetchingProducts: true });

// const getNewDashboardInfoSuccess = (state, { payload: { ...data } }) => {
//   return state
//     .merge({
//       fetchingProducts: false,
//       result: { ...state.result, ...data },
//     })
// };

// const getNextDashboardInfoRequest = (state) => state.merge({ fetchingProducts: true });

// const getNextDashboardInfoSuccess = (state, { payload: { ...data } }) => {
//   const allData = state.result.results.concat(data.results);
//   return state
//     .merge({
//       fetchingProducts: false,
//       result: { ...state.result, ...data, results: allData },
//     })
//     .setIn(['result', 'results'], allData);
// };

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LEADS_REQUEST]: getLeadsRequest,
  [Types.GET_LEADS_SUCCESS]: getLeadsSuccess,
  [Types.GET_LEADS_FAILURE]: getLeadsFailure,
  
  [Types.SEND_SELECTED_DATA_REQUEST]: sendSelectedDataRequest,
  [Types.SEND_SELECTED_DATA_SUCCESS]: sendSelectedDataSuccess,
  [Types.SEND_SELECTED_DATA_FAILURE]: sendSelectedDataFailure,

  [Types.SEND_TASK_REQUEST]: sendTaskRequest,
  [Types.SEND_TASK_SUCCESS]: sendTaskSuccess,
  [Types.SEND_TASK_FAILURE]: sendTaskFailure,

  [Types.GET_CITIES_LIST_ADMIN_REQUEST]: getCitiesListAdminRequest,
  [Types.GET_CITIES_LIST_ADMIN_SUCCESS]: getCitiesListAdminSuccess,
  [Types.GET_CITIES_LIST_ADMIN_FAILURE]: getCitiesListAdminFailure,

  [Types.RESET_API_ENDPOINTS]: resetApiEndpoints,
  
  [Types.RESET_RESULTS]: resetResults,
  [Types.RESET_ERRORS]: resetErrors,
})
